/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { isDevMode } from '@angular/core';
import { AppModule } from './app/app.module';
import { splashHide } from './app/shared/native-splash';
import { IS_NATIVE } from './app/shared/platform.util';

if (!isDevMode()) {
  console.log = () => {};
  console.debug = () => {};
  console.warn = () => {};
}

function hideHtmlSplash() {
  const el = document.getElementById('app-splash');
  if (!el) return;
  el.classList.add('splash--fade');   // animación de salida
  setTimeout(() => el.remove(), 300); // y luego lo removés del DOM
}

async function hideAllSplash() {
  // HTML splash
  hideHtmlSplash();
  // Native splash
  await splashHide();
}

// failsafe: aunque bootstrap se cuelgue, salí del splash nativo igual
if (IS_NATIVE) {
  setTimeout(() => {
    splashHide();
  }, 4000);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(async () => {
    await hideAllSplash();
  })
  .catch(async (err) => {
    console.error("❌ Error al iniciar Angular:", err);
    await hideAllSplash(); // si algo falla, igual soltá splash nativo
  });